
import React, {Component} from 'react'
import ClockingView from '../Clocking/ClockingView'
import SettingsView from '../Settings/SettingsView'
import VenueDialogue from '../NewOrder/Venue/VenueDialogue';
import PagerNumberView from '../NewOrder/PagerNumberView'
import TableSelectionView from '../NewOrder/TableSelectionView'
import FreebiesDialogue from '../NewOrder/FreebiesDialogue';
import GuestMealDialogue from '../NewOrder/GuestMealDialogue'
import CustomerForm from '../NewOrder/Customer/CustomerForm'
import CashFloatDialogue from '../CashFloat/CashFloatDialogue'
import DiscountVoucherView from '../DiscountVoucher/DiscountVoucherView'

const navigationButtonsIds = require('./navigationButtonsIds');
const storefrontUtility = require('../../utils/domain/storefrontUtility');
const saleInitializer = require('../../utils/domain/sales/saleInitializer');
const constants = require('../../utils/domain/constants');
const stringUtil = require('../../utils/string/stringUtil');
const validator = require('../../utils/validator/validator');
const saleContextUtil = require('../Order/utils/saleContextUtil');

class NavigationDialogueFacade extends Component 
{
    render()
    {
        if(navigationButtonsIds.clockingButton == this.props.params.id)
            return <ClockingView staff={this.props.params.staff}/>

        if(navigationButtonsIds.settings == this.props.params.id)
            return <SettingsView/>

        if(navigationButtonsIds.cashingUp == this.props.params.id)
            return <CashFloatDialogue/>
            
        if(navigationButtonsIds.voucher == this.props.params.id)
            return <DiscountVoucherView/>

        if(navigationButtonsIds.takeAway == this.props.params.id)
        {
            if (this.props.params.component == "pager")
                return <PagerNumberView sale={this.props.params.sale}/>
            
            if (this.props.params.component == "VenueDialogue")
                return <VenueDialogue dialoguePayload={this.props.params}/>
        }

        if(navigationButtonsIds.dineIn == this.props.params.id)
        {
            if (this.props.params.component == "table")
                return <TableSelectionView/>

            if (this.props.params.component == "VenueDialogue")
                return <VenueDialogue dialoguePayload={this.props.params}/>
        }

        if(navigationButtonsIds.collection == this.props.params.id)
        {
            if (this.props.params.component == "customer")
            {
                let customer = this.props.params.existingCustomer;
                if (customer == null)
                    customer = {};

                return <CustomerForm existingCustomer={customer} dispatchType={constants.DispatchTypeCollection} onSubmit={(customer, deliveryData) =>
                        {
                            this.createCustomerSale(constants.DispatchTypeCollection, customer, deliveryData);
                        }}/>
            }

            if (this.props.params.component == "VenueDialogue")
                return <VenueDialogue dialoguePayload={this.props.params}/>
        }

        if(navigationButtonsIds.delivery == this.props.params.id)
        {
            if (this.props.params.component == "customer")
            {
                let customer = this.props.params.existingCustomer;
                if (customer == null)
                    customer = {};

                return <CustomerForm existingCustomer={customer} dispatchType={constants.DispatchTypeDelivery} onSubmit={(customer, deliveryData) =>
                        {
                            this.createCustomerSale(constants.DispatchTypeDelivery, customer, deliveryData);
                        }}/>
            }
                
            if (this.props.params.component == "VenueDialogue")
                return <VenueDialogue dialoguePayload={this.props.params}/>
        }

        if(navigationButtonsIds.guestMeal == this.props.params.id)
            return <GuestMealDialogue/>
            

        if(navigationButtonsIds.freebies == this.props.params.id)
            return <FreebiesDialogue />
        return null;
    }

    createCustomerSale(dispatchType, customer, deliveryData)
    {
        if (customer == null)
            return;

        let sale = saleInitializer.createNewSale(storefrontUtility.getCurrentStorefrontVenueCode(), dispatchType, storefrontUtility.getCurrentStorefront().id);
        sale.customerId = customer.id;

        let dispatchInfo = {};
        dispatchInfo.customerName = customer.name;
        dispatchInfo.customerPhoneNumber = customer.phoneNumber;
        dispatchInfo.customerRating = customer.rating;
        dispatchInfo.dispatchType = dispatchType;

        if (dispatchType == constants.DispatchTypeDelivery && !stringUtil.isStringNullOrEmpty(deliveryData.selectedAddress))
        {
            dispatchInfo.deliveryAddress = deliveryData.selectedAddress;
            dispatchInfo.distance = deliveryData.deliveryDistance;
        }

        sale.dispatchInfo = JSON.stringify(dispatchInfo);

        if (!stringUtil.isStringNullOrEmpty(deliveryData.deliveryCharges) && 
            validator.isNumeric(deliveryData.deliveryCharges) &&
            deliveryData.deliveryCharges * 1 > constants.numericThresholdValue)
        {
            var serviceCharge = {};
            serviceCharge.type = constants.ChargesTypes.VenueDeliveryCharges;
            serviceCharge.amount = deliveryData.deliveryCharges * 1;
            serviceCharge.vat = 0;
            serviceCharge.notes = null;
            sale.charges.push(serviceCharge);    
        }

        const saleContext = saleContextUtil.instantiateSaleContext(sale, false);
        saleContext.customerContext = {};
        saleContext.customerContext.customer = customer;
        saleContext.customerContext.deliveryData = deliveryData;
        saleContextUtil.openSaleContext(saleContext);

    }
}

export default NavigationDialogueFacade